module.exports = __webpack_public_path__ + "media/3_21.6ae31c0b.wav";